// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"e0fe1439","314":"f1984c20","501":"c4b2b23a","635":"f887119d","748":"d16905f4"}[chunkId] + ".chunk.css";
};